import React, { Component } from 'react';
import { Chart } from 'primereact/chart';
import { SelectButton } from 'primereact/selectbutton';
import { UtilService } from 'hay-core-react';
import DashboardAjuda from './DashboardAjuda';

const OPCOES_TIPO = [
    { icon: 'pi pi-chart-bar', value: 'bar' },
    { icon: 'pi pi-chart-pie', value: 'polarArea' },
];

// Mesmo matiz (azul) para todas as fatias/barras — só a luminosidade varia, do bem claro (poucos
// acessos) ao intenso (horário de pico), funcionando como um "heatmap" por hora, reforçando
// visualmente o que o raio/altura já mostra.
function corPorIntensidade(quantidade, maxQuantidade) {
    if (!maxQuantidade) return 'hsl(217, 91%, 92%)';
    const intensidade = quantidade / maxQuantidade;
    const luminosidade = 92 - intensidade * 52; // 92% (claro) até 40% (intenso)
    return `hsl(217, 91%, ${luminosidade}%)`;
}

class DashboardGraficoHorarios extends Component {
    state = { tipo: 'bar' };

    render() {
        const { titulo, itens, help } = this.props;
        const { tipo } = this.state;

        const seletor = (
            <SelectButton
                value={tipo}
                onChange={(e) => e.value && this.setState({ tipo: e.value })}
                options={OPCOES_TIPO}
                optionValue="value"
                itemTemplate={(opt) => <i className={opt.icon} />}
            />
        );

        if (!itens || itens.every((item) => item.quantidade === 0)) {
            return (
                <div className="surface-card shadow-2 border-round p-3 h-full">
                    <div className="flex justify-content-between align-items-center mb-3">
                        <div className="text-lg font-medium">{titulo}<DashboardAjuda texto={help} /></div>
                        {seletor}
                    </div>
                    <div className="text-color-secondary text-center p-4">
                        {UtilService.traduzir('main.dashboard.grafico.semdados')}
                    </div>
                </div>
            );
        }

        const maxQuantidade = Math.max(...itens.map((item) => item.quantidade));
        const cores = itens.map((item) => corPorIntensidade(item.quantidade, maxQuantidade));
        // Labels completos ("09h") para o título do tooltip; nas barras, os ticks do eixo X usam
        // só o número (ver scales.x.ticks.callback) para não poluir o eixo com 24 labels.
        const labels = itens.map((item) => `${String(item.hora).padStart(2, '0')}h`);

        const data = {
            labels,
            datasets: [{
                data: itens.map((item) => item.quantidade),
                backgroundColor: cores,
                hoverBackgroundColor: cores,
                borderColor: tipo === 'polarArea' ? 'rgba(255, 255, 255, 0.6)' : cores,
                borderWidth: 1,
                barPercentage: 0.9,
                categoryPercentage: 1,
            }],
        };

        const options = tipo === 'polarArea' ? {
            maintainAspectRatio: false,
            plugins: {
                legend: { display: false },
            },
            scales: {
                r: {
                    beginAtZero: true,
                    ticks: { display: false },
                },
            },
        } : {
            maintainAspectRatio: false,
            plugins: {
                legend: { display: false },
            },
            scales: {
                x: {
                    ticks: {
                        autoSkip: false,
                        maxRotation: 0,
                        minRotation: 0,
                        font: { size: 9 },
                        callback: (valor, indice) => String(itens[indice].hora).padStart(2, '0'),
                    },
                },
                y: { beginAtZero: true, ticks: { precision: 0 } },
            },
        };

        return (
            <div className="surface-card shadow-2 border-round p-3 h-full" style={{ minWidth: 0 }}>
                <div className="flex justify-content-between align-items-center mb-3">
                    <div className="text-lg font-medium">{titulo}<DashboardAjuda texto={help} /></div>
                    {seletor}
                </div>
                <Chart type={tipo} data={data} options={options} style={{ width: '100%', height: '220px' }} />
            </div>
        );
    }
}

export default DashboardGraficoHorarios;
